import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { getBreakpointFromManor } from 'ctm-components';

import { PaymentFrequencyFilterDropdown } from '../../products/filters/common/payment_frequency_filter_dropdown';
import { ProductPrice } from '../../products/products/common/product_price';
import { ProceedWithProvider } from '../../products/products/common/proceed_with_provider';
import { withQuoteFlatten } from '../../products/products/common/with_quote_flatten';
import { PriceMonthlyNotice } from './price_monthly_notice';

const useStyles = createUseStyles((theme) => ({
    container: {
        padding: {
            top: '0.4rem',
            right: '0.8rem',
            left: '0.8rem'
        }
    },
    priceCard: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.colors.primary50,
        borderRadius: theme.borderRadius.default,
        padding: {
            bottom: '0.8rem'
        },
        marginBottom: '0.8rem'
    },
    dropdownContainer: {
        marginBottom: '-1.2rem'
    },
    dropdownButton: {
        fontSize: theme.fontSize.xs,
        lineHeight: '1.6rem',
        '& div > span': {
            fontWeight: theme.fontWeight.semibold
        }
    },
    priceDollarsXs: {
        fontSize: theme.fontSize['3xl']
    },
    priceCentsXs: {
        fontSize: theme.fontSize.lg
    },
    proceedWithProviderXs: {
        fontSize: theme.fontSize.xs,
        paddingLeft: theme.spacing[8],
        paddingRight: theme.spacing[8],
        height: '4.3rem'
    }
}));

const _ProductIntroCardPrice = (props) => {
    const breakpoint = getBreakpointFromManor();
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { productAnnualPremium, productMonthlyPremium, productMonthlyFirstMonth, productAnnualisedMonthlyPremium, className, quote } = props;

    return (
        <div className={classNames('test-policyComparison-productIntroCard-price', classes.container, className)}>
            <div className={classes.priceCard}>
                <div className={classes.dropdownContainer}>
                    <PaymentFrequencyFilterDropdown
                        className={classes.dropdownButton}
                        isWithoutLabel
                        options={{ annual: 'Annual cost', monthly: 'Monthly cost' }}
                    />
                </div>
                <ProductPrice
                    productAnnualPremium={productAnnualPremium}
                    productMonthlyPremium={productMonthlyPremium}
                    priceDollarsClassName={breakpoint === 'xs' ? classes.priceDollarsXs : undefined}
                    priceCentsClassName={breakpoint === 'xs' ? classes.priceCentsXs : undefined}
                />
                <PriceMonthlyNotice
                    productMonthlyFirstMonth={productMonthlyFirstMonth}
                    productAnnualisedMonthlyPremium={productAnnualisedMonthlyPremium}
                />
            </div>
            <ProceedWithProvider
                buttonText={
                    ['xs', 'md', 'sm'].includes(breakpoint) ? 'Go to Insurer' : undefined
                }
                quote={quote}
                buttonClassName={breakpoint === 'xs' ? classes.proceedWithProviderXs : undefined} />
        </div>
    );
};

_ProductIntroCardPrice.propTypes = {
    className: PropTypes.string,

    quote: PropTypes.object.isRequired,

    productAnnualPremium: PropTypes.number,
    productMonthlyPremium: PropTypes.number,
    productMonthlyFirstMonth: PropTypes.number,
    productAnnualisedMonthlyPremium: PropTypes.number

};

const ProductIntroCardPrice = withQuoteFlatten(_ProductIntroCardPrice);

export { ProductIntroCardPrice };
